export const GET_CART_LOADING = "GET/CART/loading";
export const GET_CART_ERROR = "GET/CART/error";
export const GET_CART_SUCCESS = "GET/CART/success";

export const ADD_CART_LOADING = "ADD/CART/loading";
export const ADD_CART_ERROR = "ADD/CART/error";
export const ADD_CART_SUCCESS = "ADD/CART/success";

export const UPDATE_CART_LOADING = "UPDATE/CART/loading";
export const UPDATE_CART_ERROR = "UPDATE/CART/error";
export const UPDATE_CART_SUCCESS = "UPDATE/CART/success";

export const DELETE_CART_LOADING = "DELETE/CART/loading";
export const DELETE_CART_ERROR = "DELETE/CART/error";
export const DELETE_CART_SUCCESS = "DELETE/CART/success";
